import { Injectable } from '@angular/core';
import { BaseRestService, ServiceProperties } from '@beneficity/shared/types';
import { AxwayHttpClient } from '@beneficity/shared/util';
import { Observable } from 'rxjs';
import { AuthenticationFacade } from '../../+state/authentication.facade';

@Injectable({
  providedIn: 'root',
})
export class PrescriptionService implements BaseRestService {
  serviceProperties: ServiceProperties;
  constructor(
    private readonly http: AxwayHttpClient,
    private readonly authFacade: AuthenticationFacade
  ) {
    this.serviceProperties = {
      url: '/rbsmbl/vendor-api/v1/ext/singleSignon/v1/prescriptionServices',
    };
  }

  getSSOPayload(
    brand: string,
    payloadInfo: any
  ): Observable<IPrescriptionServiceResponse> {
    const headers: { [key: string]: string } = {
      Authorization: `Bearer ${this.authFacade.getAccessToken()}`,
      'Content-Type': 'application/json',
      brand: brand.toUpperCase(),
    };

    const payload = {
      payload: {
        umi: payloadInfo?.umi,
        firstName: payloadInfo?.member?.contact?.firstName,
        lastName: payloadInfo?.member?.contact?.lastName,
        dateOfBirth: payloadInfo?.member?.contact?.birthDate,
        gender: payloadInfo?.member?.gender,
        relationshipCode: payloadInfo?.member?.relationshipCode,
        relationship: payloadInfo?.member?.relationship,
        directPaySeniorMember: payloadInfo?.dpsm,
        targetType: 'PRESCRIPTION_COSTS_AND_SAVINGS',
        clientid: payloadInfo?.clientNumber,
        vendorName: payloadInfo?.vendorName,
        groupNumber: payloadInfo?.groupNumber,
      },
    };

    return this.http.post(this.serviceProperties, payload, headers);
  }
}

export interface IPrescriptionServiceResponse {
  payload: IPrescriptionServiceData;
}

export interface IPrescriptionServiceData {
  ssoUrl: string;
  ssoRequestType: string;
  ssoFormParams: [
    {
      name: string;
      value: string;
    }
  ];
}
